import {
  AntDesign,
  BootstrapIcon,
  CssIcon,
  FigmaIcon,
  HtmlIcon,
  JqueryIcon,
  JsIcon,
  NextjsIcon,
  ReactIcon,
  SassIcon,
  TailwindIcon,
  WordpressIcon,
} from "../icons/icon";
import { Images } from "../images";

export const experienceData = [
  {
    id: 4,
    position: "Frontend Developer",
    experienceTimeline: "2024 - Present",
    companyName: "Macrotech, Surat",
    highlight:
      "Building hospitality dashboard-style product interfaces with cleaner flows, stronger component reuse, and polished UI details.",
  },
  {
    id: 3,
    position: "Sr. Web Designer",
    experienceTimeline: "2023 - 2024",
    companyName: "Zluck Solution, Surat",
    highlight:
      "Led interface design and frontend delivery for client websites with a stronger focus on brand consistency and conversion.",
  },
  {
    id: 2,
    position: "Web Designer",
    experienceTimeline: "2021 - 2023",
    companyName: "Sparkle Infotech, Surat",
    highlight:
      "Designed and shipped websites across multiple industries while improving responsiveness, layout structure, and visual quality.",
  },
  {
    id: 1,
    position: "Web Designer",
    experienceTimeline: "2020",
    companyName: "WELTEC institute, Vadodara",
    highlight:
      "Started professional web design work by translating concepts into usable, production-ready website pages.",
  },
  {
    id: 0,
    position: "B.E. in Computer Engineering",
    experienceTimeline: "2010 - 2014",
    companyName: "C. U. Shah college, Surendranagar",
    highlight:
      "Built the technical foundation that now supports my design thinking and frontend development work.",
  },
];

export const ProjectsData = [
  {
    id: 4,
    siteName: "Queryloom",
    technology: "React - Bootstrap",
    techIcon: ReactIcon,
    imageId: Images.Projectimage17,
    siteUrl: "https://queryloom.com/",
    category: "Web application interface",
    summary:
      "A modern frontend with structured layout, responsive components, and product-focused presentation.",
  },
  {
    id: 5,
    siteName: "privateLINE",
    technology: "Nextjs",
    techIcon: NextjsIcon,
    imageId: Images.Projectimage16,
    siteUrl: "https://privateline.io/",
    category: "Marketing website",
    summary:
      "A sleek brand-led website with a cleaner story flow and stronger visual rhythm.",
  },

  {
    id: 6,
    siteName: "RiseTV",
    technology: "Wordpress | HTML-CSS ",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage13,
    siteUrl: "https://rise.tv/",
    category: "Media brand website",
    summary:
      "A content-driven website built to support a stronger visual identity and clear browsing paths.",
  },
  {
    id: 7,
    siteName: "Australian Air Conditioning & Electrical",
    technology: "Wordpress | Custom Theme ",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage19,
    siteUrl: "https://aacae.com.au/",
    category: "Service business site",
    summary:
      "A custom theme experience designed to make service information and trust signals easier to scan.",
  },
  {
    id: 8,
    siteName: "C6ESG",
    technology: "Wordpress | Custom Theme ",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage15,
    siteUrl: "https://c6esg.com/",
    category: "Corporate website",
    summary:
      "A cleaner corporate presentation with structured sections, sharper hierarchy, and stronger readability.",
  },
  {
    id: 9,
    siteName: "FieldXperience",
    technology: "Wordpress | Oxygen Builder ",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage9,
    siteUrl: "https://fieldxperience.com/",
    category: "Brand and marketing site",
    summary:
      "A polished website focused on storytelling, responsive sections, and a modern visual feel.",
  },
  {
    id: 10,
    siteName: "Atlas Economics",
    technology: "Wordpress | WPBakery ",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage5,
    siteUrl: "https://atlaseconomics.com.au/",
    category: "Professional services site",
    summary:
      "A business website where content-heavy pages were made more digestible through cleaner layout structure.",
  },
  {
    id: 11,
    siteName: "LoveDevani",
    technology: "Wordpress | Oxygen Builder ",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage4,
    siteUrl: "https://lovedevani.com/",
    category: "Personal brand website",
    summary:
      "A personality-led site with a softer visual system and clearer content flow.",
  },
  {
    id: 12,
    siteName: "Mediation Northwest",
    technology: "Wordpress | WPBakery ",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage6,
    siteUrl: "https://mediationnorthwest.com/",
    category: "Informational service site",
    summary:
      "A professional website designed to improve trust, readability, and navigation across informational pages.",
  },
  {
    id: 13,
    siteName: "Designpax",
    technology: "Wordpress | WooCommerce ",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage2,
    siteUrl: "https://www.designpax.com/",
    category: "Commerce website",
    summary:
      "An e-commerce experience with better product presentation and clearer layout spacing.",
  },
  {
    id: 14,
    siteName: "PureRealEstate",
    technology: "Wordpress | WPBakery ",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage11,
    siteUrl: "https://purerealestategroup.com.au/",
    category: "Real estate website",
    summary:
      "A property-focused website built to make listings and key actions easier to discover.",
  },
  {
    id: 15,
    siteName: "Pabau",
    technology: "Wordpress | Elementor",
    techIcon: WordpressIcon,
    imageId: Images.Projectimage18,
    siteUrl: "https://pabau.com/",
    category: "Product marketing site",
    summary:
      "A polished marketing site shaped around cleaner content presentation and section-based storytelling.",
  },
];

export const Skillset1 = [
  {
    id: 0,
    techName: "Wordpress",
    techIcon: WordpressIcon,
  },
  {
    id: 1,
    techName: "React JS",
    techIcon: ReactIcon,
  },
  {
    id: 2,
    techName: "Next JS",
    techIcon: NextjsIcon,
  },
  {
    id: 3,
    techName: "Javascript",
    techIcon: JsIcon,
  },
  {
    id: 4,
    techName: "jQuery",
    techIcon: JqueryIcon,
  },
];

export const Skillset2 = [
  {
    id: 0,
    techName: "HTML",
    techIcon: HtmlIcon,
  },
  {
    id: 1,
    techName: "CSS",
    techIcon: CssIcon,
  },
  {
    id: 2,
    techName: "Bootstrap",
    techIcon: BootstrapIcon,
  },
  {
    id: 3,
    techName: "Tailwind",
    techIcon: TailwindIcon,
  },
  {
    id: 4,
    techName: "Ant Design",
    techIcon: AntDesign,
  },
  {
    id: 5,
    techName: "SCSS/SASS",
    techIcon: SassIcon,
  },
  {
    id: 6,
    techName: "Figma",
    techIcon: FigmaIcon,
  },
];
